<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qq3m0W/tc-custom/9780802190178.jpg?1728726930893" alt="This image is the cover for the book Kindness of Enemies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kindness of Enemies
      </h1>
      <p class="bookDescription body article font2">
        <b>“A richly imagined novel about a half-Russian, half-Sudanese professor whose studies of a 19th-century Muslim leader become a portal into his world.” —</b><b><i>Travel + Leisure</i></b><br/>  <br/> It’s 2010 and Natasha, a half-Russian, half-Sudanese professor of Islamic studies, is researching the life of Imam Shamil, the nineteenth-century Muslim leader who led the anti-Russian resistance in the Caucasian War. When shy, single Natasha discovers that her star student, Oz, is not only descended from the warrior but also possesses Shamil’s priceless sword, the Imam’s story comes vividly to life. As Natasha’s relationship with Oz and his alluring actress mother intensifies, Natasha is forced to confront issues she had long tried to avoid—that of her Muslim heritage. When Oz is suddenly arrested at his home one morning, Natasha realizes that everything she values stands in jeopardy.<br/>  <br/> Told with Aboulela’s inimitable elegance and narrated from the point of view of both Natasha and the historical characters she is researching, <i>The Kindness of Enemies </i>is both an engrossing story of a provocative period in history and an important examination of what it is to be a Muslim in a post 9/11 world.<br/>  <br/> “A versatile prose stylist . . . [Aboulela is] a voice for multiculturalism.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leila Aboulela
      </h2>
      
      <p class="authorDescription body article">Leila Aboulela was born in 1964 and grew up in Khartoum, Sudan. She is the author of <I>Minaret</I> and <I>Coloured Lights</I>, and winner of the Caine Prize for African Writing. <I>The Translator</I> is her first novel and was nominated for the Orange Prize and the IMPAC Dublin Award, and shortlisted for the Saltire Prize. Her work has been translated into six languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c2b71b88